// extracted by mini-css-extract-plugin
export default {"wrapper":"Q0Ta0DEv180KJiKKMWlV","warningBlock":"PIPRDTvaeQBw3IG13zYr","warningText":"blOpYjisqkChVyTIaSgq","warningCircleIcon":"sFH7zQi2QuOgD20_gWuw"};